import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { bannerService } from "../admin/services/BannerService";

interface Slide {
  bg: string;
  tag: string;
  title: string;
  titleEm: string;
  sub: string;
  thumb: string;
  thumbLabel: string;
  link?: string; // ✅ ADD THIS
}

const API_PATH = process.env.REACT_APP_API_PATH;

// const slides: Slide[] = [
//   {
//     bg: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=1200&q=80',
//     tag: 'New Collection',
//     title: 'Lunar',
//     titleEm: 'Necklace',
//     sub: 'Holy Jewelry & Diamond Pendants',
//     thumb: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=200&q=80',
//     thumbLabel: 'Necklace',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=1200&q=80',
//     tag: 'Exclusive',
//     title: 'Diamond',
//     titleEm: 'Rings',
//     sub: 'Timeless Elegance & Luxury',
//     thumb: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=200&q=80',
//     thumbLabel: 'Rings',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=1200&q=80',
//     tag: 'Trending',
//     title: 'Gold',
//     titleEm: 'Bracelets',
//     sub: 'Bold & Statement Pieces',
//     thumb: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=200&q=80',
//     thumbLabel: 'Bracelets',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1589128777073-263566ae5e4d?w=1200&q=80',
//     tag: 'Bestseller',
//     title: 'Pearl',
//     titleEm: 'Earrings',
//     sub: 'Classic & Refined Beauty',
//     thumb: 'https://images.unsplash.com/photo-1589128777073-263566ae5e4d?w=200&q=80',
//     thumbLabel: 'Earrings',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?w=1200&q=80',
//     tag: 'Limited Edition',
//     title: 'Rose Gold',
//     titleEm: 'Bangles',
//     sub: 'Handcrafted & Unique Design',
//     thumb: 'https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?w=200&q=80',
//     thumbLabel: 'Bangles',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=1200&q=80',
//     tag: 'Premium',
//     title: 'Emerald',
//     titleEm: 'Pendants',
//     sub: 'Rare Gems & Fine Crafting',
//     thumb: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=200&q=80',
//     thumbLabel: 'Pendants',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=1200&q=80',
//     tag: 'Signature',
//     title: 'Cocktail',
//     titleEm: 'Rings',
//     sub: 'Bold & Glamorous Style',
//     thumb: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=200&q=80',
//     thumbLabel: 'Cocktail',
//   },
//   {
//     bg: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=1200&q=80',
//     tag: 'Bridal',
//     title: 'Bridal',
//     titleEm: 'Sets',
//     sub: 'Forever & Always Yours',
//     thumb: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=200&q=80',
//     thumbLabel: 'Bridal',
//   },
// ];

const DURATION = 5000;
const pad = (n: number): string => String(n + 1).padStart(2, '0');

const HeroSlider: React.FC = () => {
  const [slides, setSlides] = useState<Slide[]>([]);

const [cur, setCur] = useState<number>(0);
  const [progress, setProgress] = useState<number>(0);
  const [paused, setPaused] = useState<boolean>(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const thumbRowRef = useRef<HTMLDivElement>(null);
  // const touchStartX = useRef<number>(0);

  const touchStartX = useRef<number>(0);

useEffect(() => {

}, []);

useEffect(() => {

  async function loadBanners() {

    try {

      const data =
        await bannerService.getAll();

      const heroSlides = data

        .filter(
          (b: any) =>
            b.position === "hero" &&
            b.bannerStatus === true
        )

        .sort(
          (a: any, b: any) =>
            a.displayOrder - b.displayOrder
        )

        .map((b: any) => ({

          bg:
            `${API_PATH}/uploads/${b.bannerImage}`,

          tag:
            b.tag || "",

          title:
            b.bannerTitle || "",

          titleEm:
            b.titleEm || "",

          sub:
            b.bannerSubTitle || "",

          thumb:
            `${API_PATH}/uploads/${b.thumbnailImage}`,

          thumbLabel:
            b.thumbnailLabel || "",

          link:
            b.buttonLink || "/shop"

        }));

      setSlides(heroSlides);

    } catch (error) {

      console.error(
        "Failed to load banners",
        error
      );
    }
  }

  loadBanners();

}, []);

  const scrollThumb = useCallback((idx: number) => {
    const row = thumbRowRef.current;
    if (!row) return;
    const thumbEls = row.querySelectorAll<HTMLDivElement>('.thumb-item');
    if (!thumbEls[idx]) return;
    const thumb = thumbEls[idx];
    const scrollLeft = thumb.offsetLeft - row.offsetWidth / 2 + thumb.offsetWidth / 2;
    row.scrollTo({ left: scrollLeft, behavior: 'smooth' });
  }, []);

 const goTo = useCallback((n: number) => {

  if (!slides.length) return;

  const next =
    ((n % slides.length) + slides.length) % slides.length;

  setCur(next);

  setProgress(0);

  scrollThumb(next);

}, [slides.length, scrollThumb]);

  useEffect(() => {
    if (paused) return;
    const step = 100 / (DURATION / 50);
    let val = progress;
    timerRef.current = setInterval(() => {
      val += step;
      if (val >= 100) {
        clearInterval(timerRef.current!);
        goTo(cur + 1);
      } else {
        setProgress(val);
      }
    }, 50);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cur, paused]);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.changedTouches[0].screenX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? cur + 1 : cur - 1);
  };
if (!slides.length) return null;
  return (
    <section className="jewelry-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* HERO SLIDER */}
            <div
              className="hero-slider-wrap"
              id="heroSlider"
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              {slides.map((slide, i) => (
                <div key={i} className={`hero-slide${i === cur ? ' active' : ''}`}>
                  <div
                    className="slide-bg"
                    style={{ backgroundImage: `url('${slide.bg}')` }}
                  ></div>
                  <div className="slide-overlay"></div>
                  <div className="slide-content">
                    <span className="slide-tag">{slide.tag}</span>
                    <div className="slide-divider"></div>
                    <h1 className="slide-title">
                      {slide.title} <em>{slide.titleEm}</em><br />Jewellery
                    </h1>
                    <p className="slide-sub">{slide.sub}</p>
                    <Link
  to={slide.link || "/shop"}
  className="shop-btn"
>
  Shop Now
</Link>
                  </div>
                </div>
              ))}

              {/* Counter */}
              <div className="slide-counter">
                <span id="curNum">{pad(cur)}</span> / {String(slides.length).padStart(2, '0')}
              </div>

              {/* Arrows */}
              <div className="slider-arrows">
                <button className="arr-btn" onClick={() => goTo(cur - 1)}>&#8592;</button>
                <button className="arr-btn" onClick={() => goTo(cur + 1)}>&#8594;</button>
              </div>
            </div>
            {/* /HERO SLIDER */}

            {/* THUMBNAILS */}
            <div className="thumb-row" id="thumbRow" ref={thumbRowRef}>
              {slides.map((slide, i) => (
                <div
                  key={i}
                  className={`thumb-item${i === cur ? ' active' : ''}`}
                  data-i={i}
                  onClick={() => goTo(i)}
                >
                  <div className="thumb-img-wrap">
                    <img src={slide.thumb} alt={slide.thumbLabel} />
                  </div>
                  <p className="thumb-label">{slide.thumbLabel}</p>
                </div>
              ))}
            </div>

            {/* PROGRESS */}
            <div className="progress-bar-wrap">
              <div className="progress-fill" style={{ width: `${progress}%` }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
